import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import RcPagination from "rc-pagination";
import localeInfo from "rc-pagination/lib/locale/en_US";

import { Table, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import Person from "../assets/img/account_circle_black_24dp.svg";
import { doRequest } from "../utils/helper";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import SearchHeader from "../components/SearchHeader";
import AdminFooter from "../components/AdminFooter";

export default function UserManagement() {
  const [usersList, setUsersList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 20;
  const navigate = useNavigate();
  const textItemRender = (current, type, element) => {
    if (type === "prev") {
      return (
        <FontAwesomeIcon
          icon={["fas", "chevron-left"]}
          className="font-size-sm"
        />
      );
    }
    if (type === "next") {
      return (
        <FontAwesomeIcon
          icon={["fas", "chevron-right"]}
          className="font-size-sm"
        />
      );
    }
    return element;
  };

  const getUsersList = useCallback(
    async (page = 1, search = "") => {
      try {
        setLoading(true);
        setCurrentPage(page);

        const response = await doRequest(
          "",
          "GET",
          `user/list?page=${page}&limit=${limit}&search=${search}`
        );

        if (+response?.resultFlag === 1) {
          setUsersList(response.response.user);
          setTotalRecords(response?.response?.totalRecords);
        } else {
          alert(response?.message || "Something went wrong!");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    []
  );

  // 🔹 Initial load
  useEffect(() => {
    getUsersList(1, "");
  }, [getUsersList]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    getUsersList(1, query);
  };

  const clearSearch = () => {
    setSearchQuery("");
    getUsersList(1, "");
  };

  return (
    <>
      {loading && <Loader />}

      <div className="container-fluid main">
        <Sidebar />

        <section className="home">
          <div className="container-fluid">
            <div className="searcmain_pad">

              <SearchHeader
                placeHolder="Search by name, email, phone"
                search={searchQuery}
                onChangeHandler={handleSearch}
              />

              {searchQuery && (
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted">
                    Found {totalRecords} users matching "{searchQuery}"
                  </span>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={clearSearch}
                  >
                    Clear Search
                  </button>
                </div>
              )}

              <div className="table-responsive table_user_mar">
                <Table hover striped className="table_cust align-middle">
                  <thead className="thead_bg">
                    <tr>
                      <th>User Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Subscription Plan</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {usersList?.length > 0 ? (
                      usersList?.map((item) => {
                        // console.log(item, "item")
                        return (                        
                        <tr key={item?.id}>
                          <td>
                            <ul className="dasboar_table_list">
                              <li>
                                <img
                                  src={item?.user_image || Person}
                                  alt=""
                                />
                              </li>
                              <li>
                                <h5>
                                  {item?.first_name || item?.last_name
                                    ? `${item?.first_name || ""} ${item?.last_name || ""}`
                                    : "Profile"}
                                </h5>
                              </li>
                            </ul>
                          </td>

                          <td>{item?.email}</td>
                          <td>{item?.phone}</td>

                          <td>
                            {/* {item?.plan_status === "active" ? (
                              <h6 className="enable_t">Active</h6>
                            ) : (
                              <h6 className="expire_t">Expired</h6>
                            )} */}
                            {item?.userPlan?.plan?.name}
                          </td>

                          <td>
                            {/* <h6 className="enable_t">{item?.status}</h6> */}
                            {item?.plan_status === "active" ? (
                              <h6 className="enable_t">Active</h6>
                            ) : (
                              <h6 className="expire_t">Expired</h6>
                            )}
                          </td>



                          <td>
                              <div className="viewProf_flex">
                                <Button
                                  tag="a"
                                  className="healcheck_user"
                                  onClick={() =>
                                    navigate(`/viewprofile/${item?.id}`, {
                                      state: "view",
                                    })
                                  }
                                >
                                  <img
                                    src={"/assets/images/eyepurple.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/eyewhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                  View Profile
                                </Button>

                                <Button
                                  tag="a"
                                  className="healcheck_user"
                                  style={{marginLeft: "10px"}}
                                  onClick={async () => {
                                    try {
                                      const response = await doRequest(
                                        { userId: item?.id },
                                        "POST",
                                        "user/impersonate-user"
                                      );
                                      
                                      if (response?.resultFlag === 1) {
                                        const userToken = response?.response?.token;
                                        const userEmail = response?.response?.user?.email;
                                        
                                        if (userToken && userEmail) {
                                          // Redirect to Home with token and email
                                          window.location.href = `/?token=${userToken}&email=${userEmail}`;
                                        } else {
                                          alert("Invalid response from server");
                                        }
                                      } else {
                                        alert(response?.message || "Failed to impersonate user");
                                      }
                                    } catch (error) {
                                      console.error("Impersonation error:", error);
                                      alert("Failed to impersonate user. Please try again.");
                                    }
                                  }}
                                >
                                  <img
                                    src={"/assets/images/eyepurple.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/eyewhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                    Login As User
                                </Button>


                                <Button
                                  onClick={() =>
                                    navigate(`/editprofile/${item?.id}`, {
                                      state: "edit",
                                    })
                                  }
                                  tag="a"
                                  className="edit_btn"
                                >
                                  <img
                                    src={"/assets/images/editpurple.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/editwhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                  Edit
                                </Button>
                              </div>
                            </td>
                        </tr>)
})
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-4">
                          No users found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>

              {/* Pagination */}
              {totalRecords > limit && (
                <div className="mt-2 p-4 d-flex justify-content-center">
                  <RcPagination
                    current={currentPage}
                    pageSize={limit}
                    locale={localeInfo}

                    total={totalRecords}
                    itemRender={textItemRender}
                    onChange={(page) => getUsersList(page, searchQuery)}
                  />
                </div>
              )}

            </div>
          </div>
        </section>
      </div>

      <AdminFooter />
    </>
  );
}
